import { render, staticRenderFns } from "./ms-select-check.vue?vue&type=template&id=2a9380b6&scoped=true"
import script from "./ms-select-check.vue?vue&type=script&lang=js"
export * from "./ms-select-check.vue?vue&type=script&lang=js"
import style0 from "./ms-select-check.vue?vue&type=style&index=0&id=2a9380b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9380b6",
  null
  
)

export default component.exports